module.exports = __webpack_public_path__ + "static/media/instruction_arm.06880c12.webp";